export default __webpack_public_path__ + "static/washHero-24dd9b216b493521b29cb9d9454f2077.png";